import { CardTemplate } from '~/editor/v2/cards/templates/types';
import {
  sanitizeTitleForSave,
  sanitizeBodyForSave,
  stripHtml
} from '~/editor/v2/cards/edit-modal/sanitization';
import textCardImage from '~/assets/editor/cards4-text-card.jpg';

export const textCardTemplate: CardTemplate = {
  type: 'text',
  label: 'Text Card',
  cardImage: textCardImage,

  fields: [
    {
      type: 'input',
      name: 'title',
      label: 'Title',
      maxLength: 120,
      placeholder: 'Enter title',
      sanitizer: sanitizeTitleForSave,
      defaultValue: 'Lorem Ipsum'
    },
    {
      type: 'textarea',
      name: 'body',
      label: 'Description',
      maxLength: 1200,
      placeholder: 'Enter description',
      sanitizer: sanitizeBodyForSave,
      deserializer: stripHtml,
      defaultValue:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sollicitudin sem sed fermentum consequat.'
    }
  ],

  validation: { type: 'atLeastOne', fields: ['title', 'body'] },
  createModalTitle: 'New Text Card',
  editModalTitle: 'Edit Text Card'
};
